import type { AxiosResponse } from 'axios';
import { redirect } from 'react-router';

import Auth from '../api/auth';
import MonitoringMs from '../api/monitoring';
import Provision from '../api/provision';
import rbacCheck from '../rbac/rbacCheck';
import { store, type RootState } from '../redux/store';

import createLoader from './createLoader';

export const organizationLoader = createLoader(
  Auth.fetchV1OrganizationById as unknown as () => Promise<AxiosResponse<unknown, unknown>>,
  ['organizationId']
);
export const userLoader = createLoader(
  Auth.fetchV2UserByUuid as unknown as () => Promise<AxiosResponse<unknown, unknown>>,
  ['uuid']
);
export const businessUnitLoader = createLoader(
  Auth.fetchV1BusinessUnit as unknown as () => Promise<AxiosResponse<unknown, unknown>>,
  ['businessUnitId']
);
export const projectLoader = createLoader(
  Auth.fetchV2ProjectById as unknown as () => Promise<AxiosResponse<unknown, unknown>>,
  ['projectId']
);
export const productLoader = createLoader(
  Auth.fetchV2ProductById as unknown as () => Promise<AxiosResponse<unknown, unknown>>,
  ['productId']
);
export const contactLoader = createLoader(Provision.fetchContacts, ['contactId:_id']);
export const osProjectLoader = createLoader(
  Provision.fetchOsProjectDetails as unknown as () => Promise<AxiosResponse<unknown, unknown>>,
  ['juiceGroup', 'cloudId', 'osprojectName']
);
export const caasClusterLoader = createLoader(
  Provision.fetchClusterDetailsV1 as unknown as () => Promise<AxiosResponse<unknown, unknown>>,
  ['clusterName']
);
export const getDashboardLoader = createLoader(
  MonitoringMs.getDashboard as unknown as () => Promise<AxiosResponse<unknown, unknown>>,
  ['dashboardId']
);

export const createProtectedRouteLoader = (
  permission: string,
  getData: ((state: ReturnType<typeof store.getState>) => unknown) | null = null
): (() => void) => {
  return () => {
    const state = store.getState() as RootState;
    const userData = state.user;
    const userRoles = userData.roles;

    if (userRoles?.length === 0) {
      redirect('/404');

      throw new Error('Not found');
    }

    const checkData = getData ? getData(state) : state.user.organization;
    const hasPermission = rbacCheck(userRoles, permission, checkData);

    if (!hasPermission) {
      redirect('/404');

      throw new Error('Not found');
    }
  };
};
